import { render, staticRenderFns } from "./notification-view.vue?vue&type=template&id=1c5ea6b6&scoped=true"
import script from "./notification-view.vue?vue&type=script&lang=js"
export * from "./notification-view.vue?vue&type=script&lang=js"
import style0 from "./notification-view.vue?vue&type=style&index=0&id=1c5ea6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ea6b6",
  null
  
)

export default component.exports